import 'view/css/worker.css';

import sha256 from 'crypto-js/sha256';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import API from 'service/api';

import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';

const ChangePasswordView = (props) =>
{
  const navigate = useNavigate();

  const [old_password, setOldPassword] = useState('');
  const [new_password, setNewPassword] = useState('');
  const [confirm_password, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // validate
    if (old_password.length && old_password.length < 6) return setError('密碼最少由六個字元組成。');
    if (new_password.length) {
      if (new_password.length < 6) return setError('密碼最少由六個字元組成。');
      if (confirm_password && new_password !== confirm_password) return setError('新密碼與確認密碼不吻合。');
    }
    setError('');
  }, [old_password, new_password, confirm_password]);



  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let dto = {
      old_pswd: sha256(old_password).toString(),
      new_pswd: sha256(new_password).toString()
    };
    API.changePassword(dto).then(resp => {
      if (resp.success) {
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setError('');
        PopMessage.show('已成功更改密碼', '成功', 'success');
        navigate('/');
      } else {
        setError(resp.msg);
        PopMessage.show(resp.msg, '失敗', 'danger');
      }
    });

    return false;
  }



  return (
    <div className="chpswd-frame">
      <h2>更改密碼</h2>
      <Form className="change-password" onSubmit={submit}>
        { !!error && <p className="message red">{ error }</p> }
        <label className="field">
          <strong>舊密碼</strong>
          <input type="password" pattern=".{6,}"
            placeholder="舊密碼"
            title="最少6個字元。"
            onBlur={e=>setOldPassword(e.target.value)}/>
        </label>
        <label className="field">
          <strong>新密碼</strong>
          <input type="password" pattern=".{6,}"
            placeholder="新密碼"
            title="最少6個字元。"
            onBlur={e=>setNewPassword(e.target.value)}/>
        </label>
        <label className="field">
          <strong>確認新密碼</strong>
          <input type="password" pattern={new_password}
            placeholder="確認新密碼"
            title="必需與新密碼一致。"
            onBlur={e=>setConfirmPassword(e.target.value)}
          />
        </label>
        <div className="action-panel">
          <button className="btn blue">確認</button>
          <span className="dummy"></span>
        </div>
      </Form>
    </div>
  );

}

export default ChangePasswordView;